import script from "./DebugInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./DebugInfo.vue?vue&type=script&setup=true&lang=js"

import "./DebugInfo.vue?vue&type=style&index=0&id=0b2fcd91&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b2fcd91"]])

export default __exports__